import { Slide, ToastOptions } from 'react-toastify';

/** Mode for use in forms to invoke correct 'editor' */
export type FormMode = 'create' | 'update' | 'delete' | 'upload' | 'download' | 'clone';

/** Edit link/button: Cause a page reload (via onSelect), or in-place edit using modal on loaded data (via onEdit) */
/// The intention is to pass a 'navigateTo' function which will load an editor or item-specific
/// page
/** @deprecated */
export type SelectMode = 'modal' | 'reload';

/** Currency formatter. from  https://stackoverflow.com/a/16233919 */
export const dollarAU = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD'
});

/** Generic code to handle catch() in forms */
export const handleError = (e: unknown): Error => {
  if (e instanceof Error) {
    return e;
  } else {
    return new Error('Unknown error');
  }
};

export const toastOptions: ToastOptions = {
  position: 'top-right',
  autoClose: false,
  hideProgressBar: true,
  closeOnClick: true,
  transition: Slide,
  rtl: false,
  // pauseOnFocusLoss: true,
  draggable: true
  // pauseOnHover: true,
};



// WEBPACK FOOTER //
// ./src/admin/ui/common/form.ts